import React from 'react';
import { Target, Layers, Zap, Clock } from 'lucide-react';
import { ScanMetrics } from '../types/instruments';
interface ConfidenceMetricsProps {
  metrics: ScanMetrics;
  isScanning: boolean;
  lastScanTime?: string;
}
export function ConfidenceMetrics({
  metrics,
  isScanning,
  lastScanTime
}: ConfidenceMetricsProps) {
  const isConfident = metrics.certainty >= 95;
  const isFast = metrics.latency < 60;
  return <div className="grid grid-cols-4 gap-4" data-id="element-54">
      {/* Detection Confidence */}
      <div className="bg-surface p-5 rounded-card border border-border" data-id="element-55">
        <div className="flex items-center gap-2 text-text-secondary mb-3" data-id="element-56">
          <Target className="w-5 h-5" data-id="element-57" />
          <span className="text-xs font-bold uppercase tracking-wide" data-id="element-58">
            Detection Confidence
          </span>
        </div>
        <div className={`text-3xl font-bold mb-1 ${isScanning ? 'text-text-secondary' : isConfident ? 'text-success' : 'text-warning'}`} data-id="element-59">
          {isScanning ? '—' : `${metrics.certainty}%`}
        </div>
        {!isScanning && <div className="text-xs text-text-secondary" data-id="element-60">
            {isConfident ? 'Above threshold (95%)' : 'Below threshold - rescan recommended'}
          </div>}
      </div>

      {/* Items Detected */}
      <div className="bg-surface p-5 rounded-card border border-border" data-id="element-61">
        <div className="flex items-center gap-2 text-text-secondary mb-3" data-id="element-62">
          <Layers className="w-5 h-5" data-id="element-63" />
          <span className="text-xs font-bold uppercase tracking-wide" data-id="element-64">
            Items Detected
          </span>
        </div>
        <div className="text-3xl font-bold text-text-primary mb-1" data-id="element-65">
          {isScanning ? '—' : metrics.detectedCount}
        </div>
        {!isScanning && <div className="text-xs text-text-secondary" data-id="element-66">
            All items accounted for
          </div>}
      </div>

      {/* Processing Time */}
      <div className="bg-surface p-5 rounded-card border border-border" data-id="element-67">
        <div className="flex items-center gap-2 text-text-secondary mb-3" data-id="element-68">
          <Zap className="w-5 h-5" data-id="element-69" />
          <span className="text-xs font-bold uppercase tracking-wide" data-id="element-70">
            Processing Time
          </span>
        </div>
        <div className={`text-3xl font-bold mb-1 ${isScanning ? 'text-text-secondary' : isFast ? 'text-info' : 'text-warning'}`} data-id="element-71">
          {isScanning ? '—' : `${metrics.latency}ms`}
        </div>
        {!isScanning && <div className="text-xs text-text-secondary" data-id="element-72">
            {isFast ? 'Within target (<60ms)' : 'Slower than target'}
          </div>}
      </div>

      {/* Last Scan */}
      <div className="bg-surface p-5 rounded-card border border-border" data-id="element-73">
        <div className="flex items-center gap-2 text-text-secondary mb-3" data-id="element-74">
          <Clock className="w-5 h-5" data-id="element-75" />
          <span className="text-xs font-bold uppercase tracking-wide" data-id="element-76">
            Last Scan
          </span>
        </div>
        <div className="text-3xl font-bold text-text-primary mb-1" data-id="element-77">
          {isScanning ? '—' : lastScanTime || '—'}
        </div>
        {!isScanning && lastScanTime && <div className="text-xs text-text-secondary" data-id="element-78">
            Post-operative count
          </div>}
      </div>
    </div>;
}